export const POST_REQUEST = 'postRequest'
export const GET_REQUEST = 'postRequest'
export const GET_REQUEST_SUCCESS = 'getRequestSuccess'
export const GET_REQUEST_FAILURE = 'getRequestFailure'
export const SET = 'set'
export const GET = 'get'
export const RESET = 'reset'
export const INIT = 'init'
export const UNSHIFT = 'unshift'
export const SPLICE = 'splice'
export const PUSH = 'push'
export const SET_FIRSTNAME_BY_INDEX = 'setFirstNameByIndex'
export const SET_LASTNAME_BY_INDEX = 'setLastNameByIndex'
export const SET_AVATAR_IMG_BY_INDEX = 'setAvatarImgByIndex'
export const SET_GENDER_BY_INDEX = 'setGenderByIndex'
export const SET_BIRTH_DATE_BY_INDEX = 'setBirthDateByIndex'
export const SET_BIRTH_YEAR_BY_INDEX = 'setBirthYearByIndex'
export const SET_FACEBOOK_URL_BY_INDEX = 'setFacebookByIndex'
export const SET_INSTAGRAM_URL_BY_INDEX = 'setInstagramByIndex'
export const SET_LOADING_STATUS = 'setLoadingStatus'
export const SET_STATUS_MESSAGE = 'setStatusMessage'
export const SET_INDEX = 'setIndex'
export const CLEAR = 'clear'
export const SET_TOTAL_COUNT = 'setTotalCount'
